if (!customElements.get('localization-controller')) {
  customElements.define(
    'localization-controller',
    class LocalizationController extends HTMLElement {
      constructor() {
        super();
      }

      async connectedCallback() {
        this.form = this.querySelector('.localization-controller__form');
        this.countryCode = await window.getCountryCode();
        this.localizationData = await window.getLocalizationData();

        if (!this.redirect()) {
          this.changeCountryByUrl();
        }
      }

      changeCountryByUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const countryCode = urlParams.get('country_code');

        if (!countryCode) {
          return;
        }

        const countryData = this.getCountryData(countryCode);

        if (countryData && !countryData.isCustom && countryData.code != this.localizationData.countryCode) {
          this.changeCountry(countryCode);
        } else {
          window.history.replaceState(null, document.title, window.location.href.replace(/[\?&]?country_code=([^&]*)/, ''));
        }
      }

      getCountryData(countryCode) {
        return this.localizationData.countries.find(function(country) {
          return country.code == countryCode;
        });
      }

      changeCountry(countryCode) {
        if (!this.form) {
          return;
        }

        const countryData = this.getCountryData(countryCode);

        if (countryData && countryData.isCustom) {
          if (countryData.url) {
            window.location.href = countryData.url;
          }

          return;
        }

        document.cookie = "country_selected=true; expires=" + new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toUTCString() + "; path=/";

        this.form.country_code.value = countryCode;
        this.form.submit();
      }

      redirect() {
        if (window.Shopify && window.Shopify.designMode) {
          return false;
        }

        const countryData = this.getCountryData(this.countryCode);

        if (countryData && countryData.redirect) {
          window.location.href = countryData.url;

          return true;
        }

        return false;
      }
    }
  );
}